import { ca } from '@cian/analytics';

import { IFavoriteEntity } from '../../types/results';
import { getAllProducs } from '../../utils/trackings';

export function trackCheckboxAllClick(favoriteEntities: IFavoriteEntity[]) {
  const products = getAllProducs({ favoriteEntities });

  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'Click',
    label: 'ChooseAllOffersCheckbox',
    products,
  });
}
